import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=15470af0&scoped=true&lang=pug&"
import script from "./AccountInfo.vue?vue&type=script&lang=js&"
export * from "./AccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=15470af0&lang=scss&scoped=true&"
import style1 from "./AccountInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15470af0",
  null
  
)

export default component.exports